import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const NewOption = memo((props) => {
  const { clinic_service_id, options, addServiceOption } = props;
  const initialOptionState = {
    option_id: '',
    price: '',
    note: ''
  }
  const [currentOption, setCurrentOption] = useState(initialOptionState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentOption({
      ...currentOption,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicServiceOptionSubmit = () => {
    if (!currentOption.option_id) {
      alert("※オプションは必須選択です。");
      return
    }

    var data = {
      service_option: {
        clinic_service_id: clinic_service_id,
        option_id: parseInt(currentOption.option_id, 10),
        price: parseInt(currentOption.price, 10),
        note: currentOption.note,
      }
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/api/v1/service_options`, data)
    .then(resp => {
      console.log("成功");
      console.log(resp.data);
      addServiceOption(resp.data);
      notify("success", "ServiceOption successfully created!");
      setCurrentOption({
        option_id: '',
        price: '',
        note: '',
      });
    })
    .catch(e => {
      console.log(e.response);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "ServiceOption create Error!");
    })
  }

  return (
    <>
      <div className="row">
        <div className="col-3">
          <div className="input-group mb-3">
            <span className="input-group-text" id="title-basic-enabled">OP</span>
            <select name="option_id" id="basic-options" className="form-select" value={currentOption.option_id} onChange={onChangeData}>
              <option value="">必須選択</option>
              {options.map(item => 
                <option key={item.id} value={item.id}>{item.name_ja}</option>
              )}
            </select>
          </div>
        </div>
        <div className="col-3">
          <div className="input-group mb-3">
            <span className="input-group-text">料金</span>
            <input type="number" name="price" className="form-control" value={currentOption.price} placeholder="半角数字必須" onChange={onChangeData} />
          </div>
        </div>
        <div className="col-4">
          <div className="input-group mb-3">
            <span className="input-group-text">備考</span>
            <textarea type="text" name="note" className="form-control" rows="1" placeholder="※OP備考" value={currentOption.note} onChange={onChangeData}></textarea>
          </div>
        </div>
        <div className="col-2">
          <button className="btn btn-primary" onClick={onClinicServiceOptionSubmit} disabled={(!currentOption.option_id || !currentOption.price)}>
            <i className="far fa-plus-square" /> 追加
          </button>
        </div>
      </div>
    </>
  );
});